export const validate_vergabe_id = (testID) =>
  /^[dD][3-9][0-9]{8}\b/.test(testID)
